export const getCountdownDiffSeconds = (timestamp: number = 0, COUNTDOWN_SECONDS: number) => {
    return timestamp - Math.floor(Date.now() / 1000) + COUNTDOWN_SECONDS
}
